import { CustomerFieldMappingPanel } from '@/components/Customers/CustomerFieldMappingPanel'
import { Badge } from '@/components/ui/badge'
import { useAuth } from '@/lib/auth'
import { useBusinessWorkflowDataClientHydration } from '@/lib/data-client/use-business-workflow-hydration'
import { getSampleForm, primaryFormId } from '@/lib/mock-data'
import { hasFormAdminAccess } from '@/lib/permissions'
import { useBusinessWorkflowStore } from '@/stores/businessWorkflowStore'
import { Settings2 } from 'lucide-react'
import { useMemo } from 'react'

export default function ErpCustomerFieldsRoute() {
  const { user, isLoading } = useAuth()
  useBusinessWorkflowDataClientHydration(!isLoading)
  const applications = useBusinessWorkflowStore((state) => state.applications)
  const customers = useBusinessWorkflowStore((state) => state.customers)
  const fieldMappings = useBusinessWorkflowStore((state) => state.fieldMappings)
  const updateFieldMappings = useBusinessWorkflowStore((state) => state.updateFieldMappings)
  const canEdit = hasFormAdminAccess(user)

  const primaryForm =
    [...customers, ...applications].find((record) => record.formId) ?? applications[0]
  const formId = primaryForm?.formId ?? primaryFormId
  const formTitle = primaryForm?.formTitle ?? '新客戶建檔問卷'
  const mappings = fieldMappings.filter((mapping) => mapping.formId === formId)
  const sampleApplication = applications.find((application) => application.formId === formId)
  const questions = useMemo(() => getSampleForm(formId).questions, [formId])

  if (isLoading) {
    return <div className="grid min-h-dvh place-items-center text-sm text-slate-500">載入中...</div>
  }

  if (!canEdit) {
    return (
      <div className="grid min-h-dvh place-items-center bg-slate-50 p-6 text-center">
        <div>
          <h1 className="text-lg font-semibold text-slate-950">沒有 ERP 欄位管理權限</h1>
          <p className="mt-2 text-sm text-slate-500">只有管理員可以調整客戶欄位對應設定。</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex w-[100dvw] min-w-0 max-w-[100dvw] flex-col gap-5 overflow-hidden p-4 lg:w-[var(--miao-dashboard-main-width)] lg:max-w-[var(--miao-dashboard-main-width)] lg:p-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-2xl font-semibold text-slate-950">ERP 客戶欄位</h1>
            <Badge variant="outline">mock-safe</Badge>
          </div>
          <p className="mt-1 text-sm text-slate-500">
            集中管理問卷題目與新客戶主檔欄位的對應，供新客戶申請自動帶入資料。
          </p>
        </div>
        <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-600">
          <Settings2 className="size-4 text-indigo-600" />
          此頁目前只寫入 persistent mock store
        </div>
      </div>
      <CustomerFieldMappingPanel
        formId={formId}
        formTitle={formTitle}
        questions={questions}
        mappings={mappings}
        sampleApplication={sampleApplication}
        canEdit={canEdit}
        onSave={updateFieldMappings}
      />
    </div>
  )
}
